import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';

export default function Om() {
  return (
    <article className="article-container text-[#221E1B]">
      <SeoHead
        title="Om sitet – Radiatorproblemer.dk"
        description="Om Radiatorproblemer.dk: En uafhængig dansk guide udgivet af en privatperson. Ingen salg, ingen annoncer, ingen kommercielle interesser."
        canonicalPath="/om"
      />

      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#221E1B] leading-tight mb-6">
        Om Radiatorproblemer.dk
      </h1>

      <div className="space-y-5 text-[17px] leading-[1.65]">
        <p>
          Radiatorproblemer.dk er et uafhængigt opslagsværk om radiatorer og varmeanlæg i private boliger.
        </p>

        <p>
          Sitet er skabt og udgives af en privatperson med interesse for byggeteknik og energieffektivitet. Udgiveren optræder ikke med faglig titel som autoriseret VVS-installatør eller ingeniør, og formålet med sitet er udelukkende at formidle saglig, praktisk og nøgtern viden.
        </p>

        <div className="bg-[#F3E6DC] border border-[#E6DED5] rounded p-6 my-8 space-y-3">
          <h2 className="text-base font-bold text-[#221E1B] tracking-tight">
            Sitets uafhængighed og principper
          </h2>
          <ul className="space-y-2 text-[16px] text-[#221E1B]">
            <li>
              <strong>Ingen kommercielle interesser:</strong> Sitet sælger hverken VVS-artikler, radiatorer, tilbudstjenester eller håndværkerydelser.
            </li>
            <li>
              <strong>Ingen sponsorer eller reklamer:</strong> Der modtages ingen betaling, provision eller kommission fra producenter eller håndværkerfirmaer.
            </li>
            <li>
              <strong>Kildedokumenteret indhold:</strong> Oplysninger om temperaturer, trykniveauer, forbrugsbesparelser og regulering bygger på offentligt tilgængelige tekniske vejledninger fra Energistyrelsen (SparEnergi), Teknologisk Institut, Danfoss og danske fjernvarmeselskaber.
            </li>
          </ul>
        </div>

        <h2 className="text-xl font-bold text-[#221E1B] tracking-tight mt-8 mb-3">
          Sikkerhed og grænser for gør-det-selv
        </h2>
        <p>
          Guiden lægger afgørende vægt på, at gør-det-selv-arbejde aldrig må gå ud over person- eller bygningssikkerhed. Indgreb i faste el-installationer, gasfyr, oliefyr, sikkerhedsventiler og lukkede fjernvarmestik kræver altid autorisation og må ikke udføres af privatpersoner.
        </p>
        <p>
          Hver eneste vejledning angiver tydeligt, hvad man trygt selv kan afprøve (fx udluftning, aftagning af termostathoved og let motionering af ventilstift), og i hvilke situationer man skal overlade arbejdet til en professionel fagmand.
        </p>

        <h2 className="text-xl font-bold text-[#221E1B] tracking-tight mt-8 mb-3">
          Kontakt og henvendelser
        </h2>
        <p>
          Sitet har bevidst ingen kontaktformular, e-mailadresse eller tilknyttede sociale medier. Indholdet vedligeholdes periodisk på baggrund af opdaterede regler og vejledninger fra energimyndighederne.
        </p>

        <div className="mt-12 pt-6 border-t border-[#E6DED5] flex items-center justify-between text-sm">
          <Link to="/" className="text-[#B5531E] hover:underline font-medium">
            ← Tilbage til forsiden
          </Link>
          <Link to="/ordbog" className="text-[#6B625B] hover:text-[#B5531E] hover:underline">
            Gå til ordbogen
          </Link>
        </div>
      </div>
    </article>
  );
}
